import { CustomRequestOptions } from '@/interceptors/request'
import { useUserStore } from '@/store'
import { toast } from 'sard-uniapp'

// 防抖处理登录失效的标记和定时器
let isHandlingLogout = false
let logoutTimer: number | null = null

// 防抖处理登录失效的函数
const handleLogoutWithDebounce = () => {
  if (isHandlingLogout) {
    return
  }

  isHandlingLogout = true

  // 清除之前的定时器
  if (logoutTimer) {
    clearTimeout(logoutTimer)
  }

  console.log('重新登录')
  toast.fail('登录失效, 请重新登录!')
  const userStore = useUserStore()
  // 401错误  -> 清理用户信息，跳转到登录页
  userStore.logout()

  logoutTimer = setTimeout(() => {
    uni.navigateTo({ url: '/pages-sub/login/index' })
    // 重置标记，允许下次处理
    isHandlingLogout = false
  }, 1500)
}

export const http = <T>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<IResData<T>>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          console.log('响应参数------------------->', res.data)
          const { code, msg } = res.data as any

          switch (code) {
            case 100001:
              // 无权限 需要重新登录 - 使用防抖处理
              handleLogoutWithDebounce()
              reject()
              break
            case 10012022:
            case 10012023:
            case 10000:
              resolve(res.data as IResData<T>)
              break
            case 10012140:
              uni.showToast({
                title: '商品不存在',
                icon: 'none',
              })
              setTimeout(() => {
                uni.navigateBack()
              }, 1500)
              resolve(res.data as IResData<T>)
              break
            default:
              uni.hideLoading()
              toast(msg)
              reject(msg)
              break
          }
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            uni.showToast({
              icon: 'none',
              title: (res.data as IResData<T>).msg || '请求错误',
            })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @param header 请求头，默认为json格式
 * @returns
 */
export const httpGet = <T>(
  url: string,
  query?: Record<string, any>,
  header?: Record<string, any>,
) => {
  return http<T>({
    url,
    query,
    method: 'GET',
    header,
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @param header 请求头，默认为json格式
 * @returns
 */
export const httpPost = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
  header?: Record<string, any>,
) => {
  return http<T>({
    url,
    query,
    data,
    method: 'POST',
    header,
  })
}
/**
 * PUT 请求
 */
export const httpPut = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
  header?: Record<string, any>,
) => {
  return http<T>({
    url,
    data,
    query,
    method: 'PUT',
    header,
  })
}

/**
 * DELETE 请求（无请求体，仅 query）
 */
export const httpDelete = <T>(
  url: string,
  query?: Record<string, any>,
  header?: Record<string, any>,
) => {
  return http<T>({
    url,
    query,
    method: 'DELETE',
    header,
  })
}

http.get = httpGet
http.post = httpPost
http.put = httpPut
http.delete = httpDelete
